import { render, staticRenderFns } from "./ClientQuote.vue?vue&type=template&id=67b6b269&"
import script from "./ClientQuote.vue?vue&type=script&lang=js&"
export * from "./ClientQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports